import Container from "component/atom/container/Container";
import RoundedTabs from "component/atom/Tabs/RoundedTabs";
import NewWorkflow from "component/organism/settings-workflow/new-workflow/NewWorkflow";
import SettingsWorkflowTemp from "component/organism/settings-workflow/SettingsWorkflowTemp";
import { workflow } from "hooks/endpoints";
import SettingsHeader from "pages/authenticated/layout/settingsLayout/settingsHeader/SettingsHeader";
import React, { useState } from "react";
import { useParams } from "react-router-dom";

const SettingsWorkflows = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [refetch, setRefetch] = useState(false);
  const [item, setItem] = useState(null);
  const { id } = useParams();

  const tabs = [
    {
      label: "All",
      content: (
        <SettingsWorkflowTemp
          api={workflow.getAllWorkflowsPaged}
          setRefetch={setRefetch}
          refetch={refetch}
          id={id}
          setIsOpen={setIsOpen}
          setItem={setItem}
        />
      ),
    },
    {
      label: "Custom",
      content: (
        <SettingsWorkflowTemp
          api={workflow.getAllWorkflowsPaged}
          id={id}
          isSystem={false}
          setRefetch={setRefetch}
          refetch={refetch}
          setIsOpen={setIsOpen}
          setItem={setItem}
        />
      ),
    },
    {
      label: "System",
      content: (
        <SettingsWorkflowTemp
          api={workflow.getAllWorkflowsPaged}
          id={id}
          isSystem={true}
          setRefetch={setRefetch}
          refetch={refetch}
          setIsOpen={setIsOpen}
          setItem={setItem}
        />
      ),
    },
  ];

  const handleClose = () => {
    setItem(null);
    setIsOpen(false);
  };
  return (
    <>
      <SettingsHeader
        title="Workflows"
        rightButtons={[
          {
            label: "New Workflow",
            type: "plus",
            opicBackground: true,
            func: () => setIsOpen(true),
          },
        ]}
      />
      <Container>
        <RoundedTabs tabs={tabs} />
      </Container>

      <NewWorkflow
        isOpen={isOpen}
        onClose={handleClose}
        setRefetch={setRefetch}
        id={id}
        selectedItems={item}
      />
    </>
  );
};

export default SettingsWorkflows;
